const store = {
  namespaced: true,

  state: {
    items: [],
  },

  getters: {
    items: state => state.items,
  },

  mutations: {
    SET_BREADCRUMBS (state, items) {
      state.items = items
    },
  },

  actions: {
    clear ({ commit }) {
      commit('SET_BREADCRUMBS', [])
    },
    init ({ commit }, items) {
      commit('SET_BREADCRUMBS', items)
    },
  },
}

export default store
